import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {favoriteTemplateThunk} from '~/GalleryPB/api/favorites';
import {FavoritesHeart} from '~/GalleryPB/components/FavoritesHeart';
import {LabelPremium} from '~/GalleryPB/components/Template/components/QuickView/components/LabelPremium/LabelPremium';
import {selectFavorites} from '~/GalleryPB/reducers/favorites';
import {Typography} from '~library/atoms/Typography';

import './Header.sass';

type HeaderProps = {
  title: string;
  isPremiumTemplate: boolean;
  templateId: string;
  onClose: () => void;
  openQuickView: (templateId: string) => void;
};

export const Header = ({
  title,
  isPremiumTemplate,
  templateId,
  onClose,
  openQuickView,
}: HeaderProps) => {
  const dispatch = useDispatch();
  const favorites = useSelector(selectFavorites);
  const favorited = favorites.includes(templateId);

  const onFavoriteClick = useCallback(() => {
    if (!window.isAuthenticated) {
      onClose();
    }

    openQuickView(templateId);

    dispatch(
      // @ts-expect-error function not typed
      favoriteTemplateThunk(templateId, isPremiumTemplate, favorited ? 'delete' : 'post')
    );
  }, [dispatch, templateId, isPremiumTemplate, favorited, onClose, openQuickView]);

  return (
    <div className="quick-view__content__header">
      {isPremiumTemplate && <LabelPremium className="quick-view__content__header__label_premium" />}
      <div className="quick-view__content__header__content">
        <Typography variant="header5" className="quick-view__content__header__content__title">
          {title}
        </Typography>
        <FavoritesHeart
          identifier={templateId}
          onClick={onFavoriteClick}
          favorited={favorites.includes(templateId)}
        />
      </div>
    </div>
  );
};
